export default __webpack_public_path__ + "static/media/osrcg09_2.c1b5af0e.png";